<template lang="pug">
  #body
    slot(name="header")
    #content.content
      Transition(
        name="fade-slideright"
        mode="out-in"
      )
        RouterView
    Toasters
</template>

<script>
  export default {
    components: {
      Toasters: () => import("./Toasters")
    }
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/variables.sass"
  @import "@/assets/styles/transitions.sass"

  #body
    min-height: calc(#{$body-id-height})
    padding: 0 $content-padding
    position: relative
</style>
